(function() {
	PM.Pricing = {};

	PM.Pricing.getFeatureLabels = function() {
		return {
			plan: i18next.t('Project planning'),
			people: i18next.t('Team Roster'),
			projects: i18next.t('Projects'),
			dashboard: i18next.t('Dashboard'),
			absences: i18next.t('Absences'),
			custom_theme: i18next.t('Custom theme'),
			archives: i18next.t('Project archive'),
			custom_roles: i18next.t('Custom roles'),
			project_status: i18next.t('Project status'),
			jira: i18next.t('Jira integrations'),
			api_keys: i18next.t('API keys'),
			mcp: i18next.t('MCP integration'),
			priority_support: i18next.t('Priority support')
		};
	};

	PM.Pricing.renderPricingPage = function() {
		PM.Shell.setSidebarActive('');
		PM.Shell.setBreadcrumb([{ label: i18next.t('Pricing') }]);

		var billingPromise = PM.Shell.currentUser.authenticated
			? $.get('/api/billing/current')
			: $.Deferred().resolve({ usage: { user_count: 0 } });

		return $.when(
			$.get('/api/billing/plans'),
			billingPromise,
			ejs.preloadTemplate('/app/pricing/templates/pricing.ejs'),
			ejs.preloadTemplate('/app/pricing/templates/plans.ejs')
		).then(function(plans, billing) {
			$('.js-page-container').html(ejs.rr('/app/pricing/templates/pricing.ejs', {
				plans: plans[0] || plans,
				authenticated: PM.Shell.currentUser.authenticated,
				currentTier: PM.Shell.currentUser.planTier,
				featureLabels: PM.Pricing.getFeatureLabels(),
				usage: (billing && billing[0]) ? billing[0].usage : { user_count: 0 }
			}));
		});
	};

	$(document).on('click', '.js-checkout-btn', function() {
		var $btn = $(this).prop('disabled', true);
		var tier = $btn.data('tier');
		var html = $btn.html();
		$btn.html('<span class="spinner-border spinner-border-sm me-1"></span>' + $btn.data('loading'));

		var $quantity = $('.js-plan-quantity[data-tier="' + tier + '"]');
		var quantity = $quantity.length ? parseInt($quantity.val(), 10) : 1;

		$.ajax({
			url: '/api/billing/checkout',
			method: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({ tier: tier, interval: 'monthly', quantity: quantity })
		})
			.done(function(resp) {
				if (resp.url) {
					window.location.href = resp.url;
				} else {
					window.location.reload();
				}
			})
			.fail(function(xhr) {
				$btn.prop('disabled', false).html(html);
				if (xhr.status === 401) {
					window.location.href = '/api/auth/login';
				}
			});
	});

	$(document).on('input', '.js-plan-quantity', function() {
		var $inp = $(this);
		var tier = $inp.data('tier');
		var price = parseFloat($inp.data('price'));
		var max = $inp.data('max');
		var qty = parseInt($inp.val(), 10) || 1;
		if (max && qty > max) {
			qty = max;
			$inp.val(max);
		}
		if (qty < 1) {
			qty = 1;
			$inp.val(1);
		}
		var total = price * qty;
		var $display = $('.js-plan-total-' + tier);
		$display.find('.js-plan-qty-display').text(qty);
		$display.find('.js-plan-total-display').text(total);
	});

	$(document).on('click', '.js-billing-portal-link', function(e) {
		e.preventDefault();
		$.ajax({
			url: '/api/billing/portal',
			method: 'POST',
			contentType: 'application/json'
		})
			.done(function(resp) {
				if (resp.url) {
					window.open(resp.url, '_blank');
				}
			});
	});

	page('/pricing', function(ctx) {
		if (PM.Shell.currentUser.flags && PM.Shell.currentUser.flags.pricing === false) {
			PM.Shell.renderNotFound();
			return;
		}
		PM.Pricing.renderPricingPage(ctx).then(function() {
			var params = new URLSearchParams(window.location.search);
			var checkoutTier = params.get('checkout');
			if (checkoutTier && PM.Shell.currentUser.authenticated) {
				$('.js-checkout-btn[data-tier="' + checkoutTier + '"]').trigger('click');
			}
		});
	});
})();
